import type { AnalysisTable } from '../api/types';
import type { TableSqlEntry } from '../types';

const hasSql = (sql: string | null | undefined): sql is string =>
  typeof sql === 'string' && sql.trim().length > 0;

// The SQL bound to a table's definition: one entry per column and per data row
// that carries SQL, columns first. Section headers carry none.
export const getTableSqlEntries = (table: AnalysisTable | null | undefined): TableSqlEntry[] => {
  if (!table) return [];

  const columns = table.columns.flatMap((column): TableSqlEntry[] =>
    hasSql(column.sql)
      ? [
          {
            id: `column-${column.columnId}`,
            kind: 'column',
            label: column.columnLabel,
            intent: column.intent,
            sql: column.sql,
          },
        ]
      : []
  );

  const rows = table.rows.flatMap((row): TableSqlEntry[] =>
    row.kind === 'row' && hasSql(row.sql)
      ? [
          {
            id: `row-${row.rowId}`,
            kind: 'row',
            label: row.label,
            intent: row.intent,
            sql: row.sql,
          },
        ]
      : []
  );

  return [...columns, ...rows];
};
